module.exports = __webpack_public_path__ + "img/character-13.a922ef33.png";